import { render, staticRenderFns } from "./PgaValutazioneOffertaHeaderDetails.vue?vue&type=template&id=745b3aae&"
import script from "./PgaValutazioneOffertaHeaderDetails.vue?vue&type=script&lang=ts&"
export * from "./PgaValutazioneOffertaHeaderDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VContainer,VRow,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('745b3aae')) {
      api.createRecord('745b3aae', component.options)
    } else {
      api.reload('745b3aae', component.options)
    }
    module.hot.accept("./PgaValutazioneOffertaHeaderDetails.vue?vue&type=template&id=745b3aae&", function () {
      api.rerender('745b3aae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/ValutazioneOfferta/Components/PgaValutazioneOffertaHeaderDetails.vue"
export default component.exports